import api from "@/api"

const state = {
  merchantOrders: [],
  invoices: [],
  orders: [],
  generatedInvoice: {}
}

const actions = {
  getMerchantOrders({ commit }) {
    return new Promise((resolve, reject) => {
      api.invoice.merchantOrderList().then(
        (response) => {
          commit("setMerchantOrders", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getInvoiceList({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.invoice.invoiceList(payloads).then(
        (response) => {
          commit("setInvoices", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getOrderList({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.invoice.orderList(payloads).then(
        (response) => {
          commit("setOrders", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  generateInvoice({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.invoice.orderList(payloads).then(
        (response) => {
          commit("setGeneratedInvoice", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  paid({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.invoice.paid(payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  notif({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.invoice.notif(payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}

const mutations = {
  setMerchantOrders(state, value) {
    state.merchantOrders = value
  },
  setInvoices(state, value) {
    state.invoices = value
  },
  setOrders(state, value) {
    state.orders = value
  },
  setGeneratedInvoice(state, value) {
    state.generatedInvoices = value
  }
}

const getters = {
  merchantOrders: state => state.merchantOrders,
  invoices: state => state.invoices,
  orders: state => state.orders,
  generatedInvoice: state => state.generatedInvoice
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
